import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { loadDefaultPpiWeights, loadDefaultTableRowVisibleList } from '../actions';
import PPITable from './PPITable';
import SaveBtn from './SaveBtn';
import AddTableRow from './AddTableRow';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import IconViewModule from 'material-ui/svg-icons/action/view-module';
import { indigo500, grey300 } from 'material-ui/styles/colors';

const HeaderWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 0.53em;
    padding-bottom: 0.53em;
`;

const HeaderLet = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    padding-top: 0.33em;
`;

const Title = styled.h2`
    color: ${indigo500};
    font-weight: inherit;
    margin-top: 0;
    margin-bottom: 0;

    svg {
        margin-right: 10px;
        transform: translate(0, 4px);
    }
`;

const BtnWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
`;

const CardHeaderStyle = {
    borderBottom: `1px solid ${grey300}`,
    paddingTop: 0,
    paddingBottom: 0
};

const IconTitleStyle = {
    color: 'inherit'
};

const CardStyle = {
    marginBottom: 15
};

const defaultPpi = {
    goalkeeper: {
        in_line_up: 15,
        subbed_in: 5,
        clean_sheet: 100,
        goal_assists: 100,
        goals: 240,
        saved_penalty: 100,
        saves: 20,
        total_tackle: 10,
        blocked_pass: 0,
        total_clearance: 0,
        duel_won: 5,
        total_scoring: 30,
        missed_penalty: -50,
        yellow_card: -25,
        red_card: -100,
        own_goals: -50,
        //
        home_win: 25,
        away_win: 30,
        draw: 15,
        loosing_home: -25,
        loosing_away: -15,
        goals_against: -20,
        minimum_goal_victory: 20
    },
    forward: {
        in_line_up: 15,
        subbed_in: 5,
        clean_sheet: 85,
        goal_assists: 75,
        goals: 110,
        saved_penalty: 0,
        saves: 0,
        total_tackle: 20,
        blocked_pass: 5,
        total_clearance: 2,
        duel_won: 15,
        total_scoring: 30,
        missed_penalty: -50,
        yellow_card: -25,
        red_card: -100,
        own_goals: -50,
        //
        home_win: 25,
        away_win: 30,
        draw: 15,
        loosing_home: -25,
        loosing_away: -15,
        goals_against: -20,
        minimum_goal_victory: 20
    },
    defender: {
        in_line_up: 15,
        subbed_in: 5,
        clean_sheet: 0,
        goal_assists: 75,
        goals: 110,
        saved_penalty: 0,
        saves: 0,
        total_tackle: 15,
        blocked_pass: 0,
        total_clearance: 0,
        duel_won: 15,
        total_scoring: 30,
        missed_penalty: -50,
        yellow_card: -25,
        red_card: -100,
        own_goals: -50,
        //
        home_win: 25,
        away_win: 30,
        draw: 15,
        loosing_home: -25,
        loosing_away: -15,
        goals_against: 0,
        minimum_goal_victory: 20
    },
    midfielder: {
        in_line_up: 15,
        subbed_in: 5,
        clean_sheet: 0,
        goal_assists: 50,
        goals: 110,
        saved_penalty: 0,
        saves: 0,
        total_tackle: 10,
        blocked_pass: 0,
        total_clearance: 0,
        duel_won: 5,
        total_scoring: 30,
        missed_penalty: -50,
        yellow_card: -25,
        red_card: -100,
        own_goals: -50,
        //
        home_win: 25,
        away_win: 30,
        draw: 15,
        loosing_home: -25,
        loosing_away: -15,
        goals_against: 0,
        minimum_goal_victory: 20
    }
};

const defaultTableList = [
    'home_win',
    'away_win',
    'draw',
    'loosing_home',
    'loosing_away',
    'goals_against',
    'minimum_goal_victory',
    //
    'in_line_up',
    'subbed_in',
    'clean_sheet',
    'goal_assists',
    'goals',
    'saved_penalty',
    'saves',
    'total_tackle',
    'blocked_pass',
    'total_clearance',
    'duel_won',
    'total_scoring',
    'missed_penalty',
    'yellow_card',
    'red_card',
    'own_goals'
];

class PlayerPerformanceIndex extends PureComponent {
    componentDidMount() {
        this.props.loadDefaultPpiWeights(defaultPpi);
        this.props.loadDefaultTableRowVisibleList(defaultTableList);
    }

    render() {
        return (
            <Card style={CardStyle}>
                <CardHeader style={CardHeaderStyle}>
                    <HeaderWrapper>
                        <HeaderLet>
                            <Title>
                                <IconViewModule style={IconTitleStyle} />Player Performance Formula Editor
                            </Title>
                        </HeaderLet>
                    </HeaderWrapper>
                </CardHeader>
                <CardText>
                    <PPITable />
                    <BtnWrapper>
                        <AddTableRow />
                        <SaveBtn />
                    </BtnWrapper>
                </CardText>
            </Card>
        );
    }
}

PlayerPerformanceIndex.propTypes = {
    // From connect
    loadDefaultPpiWeights: PropTypes.func.isRequired,
    loadDefaultTableRowVisibleList: PropTypes.func.isRequired
};

export default connect(
    null,
    { loadDefaultPpiWeights, loadDefaultTableRowVisibleList }
)(PlayerPerformanceIndex);



/** WEBPACK FOOTER **
 ** ../src/dash/front/ppi/components/PlayerPerformanceIndex.js
 **/